import { ExpressionSpecification, MapMouseEvent } from "mapbox-gl";

/**
 * Generates an expression that resolves to the radius of a circle on Mapbox
 * that is approximately the given radius in meters at the given latitude
 */
export function generateExpressionMetersToPixels(
	radius: number | ExpressionSpecification,
	latitude: number | ExpressionSpecification,
): ExpressionSpecification {
	return [
		"interpolate",
		["exponential", 2],
		["zoom"],
		0,
		0,
		//meters / 0.075 / cos(latitude * PI / 180) (https://stackoverflow.com/q/37599561)
		//https://docs.mapbox.com/help/glossary/zoom-level/
		22,
		[
			"/",
			["/", radius, 0.019],
			["cos", ["/", ["*", latitude, Math.PI], 180]],
		],
	];
}

/**
 * Converts a distance in meters to pixels at a given latitude and zoom level
 */
export function mapboxMetersToPixels(
	meters: number,
	latitude: number,
	zoom: number,
) {
	return (
		meters /
		0.019 /
		Math.cos((latitude * Math.PI) / 180) /
		Math.pow(2, 22 - zoom)
	);
}

/**
 * Returns whether a map mouse event is targeting a given layer, i.e. the layer
 * is the topmost layer at the event's point.
 */
export function isMapMouseEventOnLayer(
	event: MapMouseEvent,
	layerID: string,
	ignoredLayers: readonly string[] = [],
): boolean {
	const topFeatures = event.target.queryRenderedFeatures(event.point);

	// Filter out features from ignored layers
	for (const feature of topFeatures) {
		if (feature.layer !== undefined) {
			if (feature.layer.id === layerID) {
				return true;
			}

			if (!ignoredLayers.includes(feature.layer.id)) {
				return false;
			}
		}
	}

	return false;
}
